import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA Service Worker Registration with update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('SW registered:', reg.scope);

      // If a waiting worker already exists (update downloaded on previous load)
      if (reg.waiting) {
        window.dispatchEvent(new CustomEvent('pwaUpdateAvailable', { detail: reg }));
      }

      // Listen for new updates
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // There's a new SW waiting — tell the UI to show the update banner
            window.dispatchEvent(new CustomEvent('pwaUpdateAvailable', { detail: reg }));
          }
        });
      });

      // When the new SW takes control, reload the page to get fresh assets
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // Periodically check for updates (every 30 minutes while app is open)
      setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);
    }).catch((err) => {
      console.log('SW registration failed:', err);
    });
  });
}

// Capture the install prompt globally so components can use it
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPrompt = e;
  // Dispatch custom event so React components can react
  window.dispatchEvent(new CustomEvent('pwaInstallReady'));
});

window.addEventListener('appinstalled', () => {
  window.deferredPrompt = null;
  window.dispatchEvent(new CustomEvent('pwaInstalled'));
  console.log('PWA installed successfully');
});
